import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import { emailRegex } from 'common/utils/helpers';

export default () => {
    const { EMAIL_VALIDATION_TEXT, REQUIRED_TEXT, minimumNumberCharacters } =
        getValidationTexts();

    return object().shape({
        first_name: string().required(REQUIRED_TEXT).nullable(),
        last_name: string().required(REQUIRED_TEXT).nullable(),
        phone: string().required(REQUIRED_TEXT).nullable(),
        email: string()
            .required(REQUIRED_TEXT)
            .matches(emailRegex, EMAIL_VALIDATION_TEXT)
            .nullable(),
        tmp_password: string()
            .when('has_tmp_password', {
                is: true,
                then: string()
                    .required(REQUIRED_TEXT)
                    .min(8, minimumNumberCharacters(8)),
            })
            .nullable(),
        company_group: string().required(REQUIRED_TEXT).nullable(),
    });
};
